export const JOBS_ELEMENTS_PER_PAGE = 20
export const SERVICE_PROVIDERS_ELEMENTS_PER_PAGE = 20